import React, {useEffect, useState} from 'react';
import {fetchVideoConfig} from "./utils/utils";
import DOMPurify from "dompurify";

const VideoTranscript = () => {
    const [transcript, setTranscript] = useState("");

    useEffect(() => {
        fetchVideoConfig()
            .then((data) => {
                setTranscript(data.transcript);
            });
    }, []);

    return (
        <details id="video-transkript" role="region" aria-label="Transkription des Videos" className="p-4">
            <summary className="transcript-summary"><i className="fa fa-file-o"></i> Transkription anzeigen</summary>
            <div className="transcript-text">
                {<div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(transcript)}}/>}
            </div>
        </details>
    )
}

export default VideoTranscript;